export enum ColorEnum {
  DarkBlue = "#0B3F54",
  Blue = "#4367E5",
  LightBlue = "#6FC8C0",
  SeaBlue = "#144E65",
  LighSky = "#D5E8F5",
  Sky = "#F3F8FF",
  SeaSky = "#EAF2FC",
  PeacockBlue = "#73a5e8",
  Yellow = "#FED115",
  Danger = "#D25F5F",
  Gray = "#333333",
  DarkGray = "#242424",
  LightGray = "#F1F1F1",
  Grayish = "#6C6C6C",
  Black = "#000000",
  GrayishWhite = "#F8F8F8",
  White = "#FFFFFF",
  SilverGray = "#CCCCCC",
  GraniteGray = "#666666",
  MediumGray = "#9C9C9C",
  Green = "#13A446",
  LightGreen = "#b6e3c6",
  MediumGreen = "#61c283",
  Orange = "#DA7F00",
  BluishCyan = "#3C6576",
  MediumGrayish = "#DDDDDD",
  SkyBlue = "#2E79DC",
  LightSkyBlue = "#BED5F4",
  LightYellow = "#FADBB0",
  Red = "#FF0000",
  Corn = "#FFD700",
  SoyaBeans = "#6A9F59",
  Canola = "#E1AD01",
  SmallGrains = "#D2B48C",
  Sunflower = "#ff7f24",
  Pulses = "#c85b05",
  Sorghum = "#8B4513",
}
